<template>
  <div class="Mobile">
    <div class="Mobile__smoke" />
    <div class="Mobile__title">
      <img :src="require('@/components/loader/img/title_' + lang + '.png')" />
    </div>
    <div class="Mobile__text" v-html="trans(txt)" />
    <div class="Mobile__gradient" />
    <a href="https://momentabiennale.com" class="Mobile__btn button">momentabiennale.com</a>
  </div>
</template>

<script>
export default {
  name: 'Mobile',
  data: ()=>({
    txt: 'text'
  }),
  translations: {
    fr: { 
      text: "Le jeu se joue sur ordinateur et sur tablette à partir des versions les plus récentes de navigateurs (à l'exception d'Internet Explorer)",
      safari: "Votre navigateur n’est pas en mesure de rouler cette expérience. Veuillez essayer de nouveau sur le navigateur Chrome." 
    },
    en: { 
      text: 'The game can be played on a computer or tablet by using the most recent Web browsers (except Internet Explorer)' ,
      safari: "Your browser is unable to run this experience. Please try again on the Chrome browser. "
    },
  },
  mounted() {
    if(this.$root.isSafariOnPad == true || this.$root.isSafari == true) 
      this.txt = 'safari'
  },
}
</script>

<style lang="stylus">

@import '~@/config/Settings'
@import '~@/commons/stylus/Media-queries'

.Mobile
  display block
  height 100vh
  width 100vw
  background-image url('~@/components/loader/img/bg.jpg')
  background-size cover
  background-position center center

  &__btn
    position absolute
    display block
    top inherit
    left 50%
    top 50%
    transform translate(-50%, -50%)
    margin-top 150px
    width 230px

  &__gradient
    position absolute
    bottom 0px
    width 100%
    height 200px
    background-image linear-gradient(rgba(black, 0), rgba(black, 1))

  &__text
    position absolute
    top 50%
    left 50%
    transform translate(-50%, -50%)
    font-size 16px
    line-height 20px
    text-align center
    font-weight 700
    padding 0 24px
    width 100%
    max-width 390px

  &__title
    position absolute
    left 50%
    transform translateX(-50%)
    width 100%
    display flex
    justify-content center
    align-items center

    & img 
      max-width 70vh

  &__smoke
    position absolute
    bottom -40vh
    width 100vw
    height 100vh
    background-image url('~@/commons/img/smoke.png')
    background-size cover
    background-repeat no-repeat
    background-position center center
    opacity .5

</style>



// WEBPACK FOOTER //
// src/components/mobile/Mobile.vue